module.exports = __webpack_public_path__ + "img/ИФ-1(А)-002-m.f25a23eb.png";